import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { toast } from 'react-toastify';
import ReactTable from 'react-table';
import LoadingIndicator from '../../../common/loadingIndicator';
import { getTermsDatesForAdmin, updateTermsLastUpdatedDate } from './api';
import './index.css';

const TermsManagement = () => {
    const [termsDates, setTermsDates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [updating, setUpdating] = useState(null);

    const loadTermsDates = async () => {
        setLoading(true);
        try {
            const result = await getTermsDatesForAdmin();
            setTermsDates(result);
        } catch (error) {
            console.error('Error loading terms dates:', error);
            toast.error('Failed to load terms dates');
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateDate = async (categoryKey, displayName) => {
        if (!window.confirm(`Update the last modified date for "${displayName}" to now? This will prompt users to re-accept these terms.`)) {
            return;
        }

        setUpdating(categoryKey);
        try {
            await updateTermsLastUpdatedDate(categoryKey);
            toast.success(`Updated ${displayName} successfully`);
            await loadTermsDates();
        } catch (error) {
            console.error('Error updating terms date:', error);
            toast.error('Failed to update terms date');
        } finally {
            setUpdating(null);
        }
    };

    useEffect(() => {
        loadTermsDates();
    }, []);

    if (loading) {
        return <LoadingIndicator />;
    }

    if (!loading && termsDates.length === 0) {
        return (
            <div className="terms-management">
                <div className="terms-header">
                    <h2>Terms & Conditions Management</h2>
                    <p>No terms data available.</p>
                </div>
            </div>
        );
    }

    const columns = [
        {
            Header: 'Terms Category',
            accessor: 'displayName',
            minWidth: 150,
        },
        {
            Header: 'Category Key',
            accessor: 'categoryKey',
            minWidth: 120,
        },
        {
            Header: 'Description',
            accessor: 'description',
            minWidth: 200,
        },
        {
            Header: 'Last Updated',
            accessor: 'lastUpdatedDate',
            minWidth: 150,
            Cell: ({ value }) => {
                if (!value) return '';
                const m = moment.utc(value).local();
                return m.isValid() ? m.format('MMM D, YYYY, hh:mm A') : '';
            }
        },
        {
            Header: 'Actions',
            accessor: 'categoryKey',
            minWidth: 150,
            sortable: false,
            Cell: ({ value, original }) => (
                <button
                    className="btn btn-primary btn-sm"
                    onClick={() => handleUpdateDate(value, original.displayName)}
                    disabled={updating === value}
                >
                    {updating === value ? 'Updating...' : 'Update to Now'}
                </button>
            )
        }
    ];

    return (
        <div className="terms-management">
            <div className="terms-header">
                <h2>Terms & Conditions Management</h2>
                <p className="terms-description">
                    Update the last modified date when terms documents are changed. 
                    Users who accepted before this date will be prompted to re-accept terms in the mobile app.
                </p>
            </div>
            
            <ReactTable
                data={termsDates}
                columns={columns}
                defaultPageSize={10}
                className="-striped -highlight"
                minRows={0}
            />
        </div>
    );
};

TermsManagement.permission = "Admin.Terms";

export default TermsManagement;
